'use client'
import { useEffect, useId, useState } from 'react';
import { usePathname } from 'next/navigation';
import clsx from 'clsx';

import { useIsMobile } from '@/hooks/useMobile';
import {SubMenu} from './SubMenu'
import { Icon } from '@/stories/atoms/Icon/Icon';
import { MenuLink } from './MenuLink';

import styles from './menu.module.css';

export const Menu = (
  {
    menuLinks
  }: {
    menuLinks: ({
      label: string;
      url: string;
      child?: undefined;
    } | {
      label: string;
      url: string;
      child: {
        label: string;
        url: string;
      }[];
    })[]
  }
) => {
  const [open, setOpen] = useState(false)
  const id = useId()
  const pathname = usePathname()
  const { isMobile } = useIsMobile()

  // Ferme le menu mobile à chaque navigation
  const [prevPathname, setPrevPathname] = useState(pathname)
  const [prevIsMobile, setPrevIsMobile] = useState(isMobile)
  if (pathname !== prevPathname || isMobile !== prevIsMobile) {
    setPrevPathname(pathname)
    setPrevIsMobile(isMobile)
    if (isMobile) setOpen(false)
  }

  useEffect(() => {
    if (isMobile) {
      document.body.classList.remove('menu-open')
    }
  }, [pathname, isMobile])

  const toggleMenu = () => {
    setOpen(!open)
    document.body.classList.toggle('menu-open')
  }

  return (
    <div className={styles.menu}>
      <button
        type='button'
        id={id}
        className={styles.btn}
        onAuxClick={toggleMenu}
        onClick={toggleMenu}
        {...(isMobile && {"aria-expanded": open})}>
          <Icon icon='bars' size={'lg'}/>
          <span className={styles.btnLabel}>Menu</span>
        </button>
      <nav className={clsx(styles.panel, (open && isMobile) && styles.open)} {...(isMobile && {"aria-labelledby": id})} id='main-nav'>
        <button className={styles.close} onAuxClick={toggleMenu} onClick={toggleMenu}>
          <span className='sr-only'>Fermer le menu</span>
          <Icon icon='close' size={'lg'}/>
        </button>
        <ul className={styles.list}>
          { menuLinks.length > 0 && menuLinks.map((link, i ) => (
            <li key={i} className={styles.item}>
              { link.child && link.child.length > 0 ? (
                <SubMenu item={link} parentOpen={open}/>
              ) : (
                <MenuLink url={link.url} label={link.label}/>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  )
};
